// @flow

import React, { type Node } from 'react';
import '@tectonics/commons/look-and-feel/uber/asset/font/gilroy.css';
import '@tectonics/commons/look-and-feel/uber/asset/font/open-sans.css';
import { usePaymentMethods } from '@tectonics/commons/payment-methods';
import { MealVoucherPage } from './meal-voucher';

export function UberLookAndFeel(): Node {
  const paymentMethods = usePaymentMethods();

  if (paymentMethods.length !== 1 || paymentMethods[0] !== 'meal_voucher') {
    throw new Error('Only payment method "meal_voucher" is supported');
  }

  return <MealVoucherPage />;
}
